import React, { useEffect } from 'react';
import { ModalHeader, ModalBody, Typography, Button, LoadingButton, ModalFooter, Link, } from '@one-thd/sui-atomic-components';
import { setOverlayEvent } from '../../../../utils/analytics';
import { setBulkAddEventAnalytics } from '../../../../utils/add-manage-user-analytics';
export var RemoveInvalidUsers = function (_a) {
    var usersInfo = _a.usersInfo, isLoading = _a.isLoading, downloadHref = _a.downloadHref, onConfirmDelete = _a.onConfirmDelete, hideModal = _a.hideModal;
    var invalidUsersLength = usersInfo.invalidUsersLength, validUsersLength = usersInfo.validUsersLength, totalUsersLength = usersInfo.totalUsersLength;
    useEffect(function () {
        setOverlayEvent('remove invalid users and continue import');
    }, []);
    var onHideModal = function () {
        setBulkAddEventAnalytics('remove invalid users overlay: go back button');
        hideModal();
    };
    var onDelete = function () {
        setBulkAddEventAnalytics('remove invalid users overlay: continue button');
        onConfirmDelete();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: onHideModal }, "Remove Invalid Users and Continue Import"),
        React.createElement(ModalBody, null,
            React.createElement(Typography, { variant: "body-base", weight: "bold" },
                "We couldn't validate ",
                invalidUsersLength,
                " user(s). If you select to continue, only ",
                validUsersLength,
                " of ",
                totalUsersLength,
                " user(s) will be added to your account."),
            "\u00A0",
            React.createElement(Typography, { variant: "body-base" },
                "If you want to correct errors on the invalid user entries later,",
                ' ',
                React.createElement(Link, { href: downloadHref, download: "users.csv" }, "download this CSV file"),
                ", correct the errors, and resubmit.")),
        React.createElement(ModalFooter, null,
            React.createElement("div", { className: "sui-flex sui-justify-end sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row" },
                React.createElement(Button, { variant: "secondary", onClick: onHideModal }, "Go Back"),
                React.createElement(LoadingButton, { loading: isLoading, variant: "primary", onClick: onDelete, "data-testid": "removeInvalidUsersContinueBtn" }, "Continue")))));
};
